import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";

import TheTeam from "./pages/TheTeam";
import AdvisoryBoard from "./pages/AdvisoryBoard";
import JoinUs from "./pages/JoinUs";
import HowWeWork from "./pages/HowWeWork";
import Portfolio from "./pages/Portfolio";
import SocialResponsibility from "./pages/SocialResponsibility";
import News from "./pages/News";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/the-team" element={<TheTeam />} />
            <Route path="/advisory-board" element={<AdvisoryBoard />} />
            <Route path="/join-us" element={<JoinUs />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/social-responsibility" element={<SocialResponsibility />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
